export default {
  "Autocomplete.all_number_selected": "Todos os {number} selecionados",
  "Autocomplete.all_number": "Todos ({number})",
  "Card.toggle_content": "alternar conteúdo",
  "Chip.remove": "remover",
  "DatePicker.next": "Próximo",
  "DatePicker.previous": "Anterior",
  "Pagination.first": "primeiro",
  "Pagination.go_to_page_number": "Vá para a página {index}",
  "Pagination.go_to_page": "Ir para a página {label}",
  "Pagination.last": "durar",
  "Pagination.next": "próximo",
  "Pagination.previous": "anterior",
  "Table.actions": "Ações da tabela",
  "Table.add_column": "Adicionar coluna",
  "Table.filter": "Filtro",
  "Table.hide": "Esconder",
  "Table.more_actions": "Mais ações",
  "Table.move_left": "Mova para a esquerda",
  "Table.move_right": "Mover para a direita",
  "Table.not_specified": "Não especificado",
  "Table.pagination": "Paginação da Tabela",
  "Table.per_page": "Por página",
  "Table.position_zero": "0 de {total}",
  "Table.position": "{start}-{end} de {total}",
  "Table.search": "Procurar",
  "Table.select_all": "Selecionar tudo",
  "Table.select_row": "Selecione {row}",
  "Table.sort_ascending": "Ordernar ascendente",
  "Table.sort_descending": "Ordernar decrescente",
  "TextInput.clear_labelled_input": "Limpar {label}",
  "Ui.clear_all": "Limpar tudo",
  "Ui.close": "Fechar",
  "Ui.loading": "Carregando",
  "Ui.no_results": "Sem resultados",
  "Ui.number_selected": "{number} selecionado",
  "Ui.remove": "Remover",
  "Ui.select_all": "Selecionar tudo",
  "Ui.show_more": "+ {count} Mais"
}
